import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Home = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const response = await axios.get('http://localhost:5000/api/courses');
      setCourses(response.data.slice(0, 6));
      setLoading(false);
    } catch (error) {
      console.error('Error fetching courses:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      {/* Hero Section */}
      <div className="jumbotron bg-primary text-white p-5 rounded mb-4">
        <h1 className="display-4">Welcome to Education Portal</h1>
        <p className="lead">
          Your Gateway to Quality Education. Learn IT, Languages, and School Subjects.
        </p>
        <hr className="my-4" />
        <p>Start your learning journey today with our expert trainers.</p>
        <a className="btn btn-light btn-lg" href="/courses" role="button">
          Browse Courses
        </a>
      </div>

      {/* Featured Courses */}
      <h2 className="mb-4">Featured Courses</h2>
      <div className="row">
        {courses.map(course => (
          <div className="col-md-4 mb-4" key={course.id}>
            <div className="card course-card">
              {course.image && (
                <img 
                  src={`http://localhost:5000/uploads/${course.image}`} 
                  className="card-img-top" 
                  alt={course.title}
                  style={{ height: '200px', objectFit: 'cover' }}
                />
              )}
              <div className="card-body">
                <h5 className="card-title">{course.title}</h5>
                <p className="card-text">{course.short_description}</p>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-primary fw-bold">${course.price}</span>
                  <span className="badge bg-info">{course.level}</span>
                </div>
                <Link to={`/courses/${course.id}`} className="btn btn-primary mt-2 w-100">
                  View Details
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Add this if Link is not imported
import { Link } from 'react-router-dom';

export default Home;